import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { mapValues } from 'lodash/fp'
import SelectContent from 'components/select-content'
import enhance from './enhance'
import constants from '../../constants'
import Rendering from '../rendering'
import { formatDate } from '../util'
import SelectDates from './select-dates'
import SetDefault from './set-default'
import './create.css'

const { SCHEDULE_CONTENT, SET_DEFAULT_CONTENT } = constants.createNav

class Create extends Component {
  componentDidMount() {
    console.log('MOUNTED')
    this.props.fetch()
  }

  render() {
    const { nav, setNav, selectingContentType } = this.props

    return (
      <div className="create">
        <div className="schedule-content">
          <SelectContent
            isSelectingColor={
              selectingContentType ===
              constants.createNav.SELECT_CONTENT_TYPE_COLOR
            }
            selectNextContentId={this.props.selectNextContentId}
            selectPrevContentId={this.props.selectPrevContentId}
            selectContentId={this.props.selectContentId}
            selectedContentId={this.props.selectedContentId}
            selectContentType={this.props.selectContentType}
          />
        </div>
        <div className="actions">
          <div className="action-nav">
            <div
              className={`sub-heading ${nav === SCHEDULE_CONTENT &&
                'selected'}`}
              onClick={() => setNav(SCHEDULE_CONTENT)}
            >
              Schedule
            </div>
            <div
              className={`sub-heading ${nav === SET_DEFAULT_CONTENT &&
                'selected'}`}
              onClick={() => setNav(SET_DEFAULT_CONTENT)}
            >
              Set Default
            </div>
          </div>
          <ReactCSSTransitionGroup
            transitionName="slide-right"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            {nav === SCHEDULE_CONTENT && <SelectDates key="schedule" />}
          </ReactCSSTransitionGroup>
          <ReactCSSTransitionGroup
            transitionName="slide-left"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            {nav === SET_DEFAULT_CONTENT && <SetDefault key="default" />}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    )
  }
}

export default enhance(Create)



// WEBPACK FOOTER //
// ./src/components/create/index.js